// Author YuJiaBei
// Date 2022-01-25 21:21:40

class EmSicEafmREocEmrec {
constructor({
        id = null,
        emrecSeq = '',
        emrecIdEafm = '',
        eafmNodeCode = '',
        eafmName = '',
        emrecIdEoc = '',
        eocName = '',
        eocNodeId = '',
        eocNodeCode = '',
        remark = ''}
= {}) {
    this.id = id;
    this.emrecSeq = emrecSeq;
    this.emrecIdEafm = emrecIdEafm;
    this.eafmNodeCode = eafmNodeCode;
    this.eafmName = eafmName;
    this.emrecIdEoc = emrecIdEoc;
    this.eocName = eocName;
    this.eocNodeId = eocNodeId;
    this.eocNodeCode = eocNodeCode;
    this.remark = remark;
}
}

function newEntity() {
return new EmSicEafmREocEmrec();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emrecSeq',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.grid.emrecSeq',
        sortable: true,
        form: {
        type: 'inputNumber'
        }
        },
        {
        key: 'emrecIdEafm',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.grid.emrecIdEafm',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eafmNodeCode',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.grid.eafmNodeCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eafmName',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.grid.eafmName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eafmParentId',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.grid.eafmParentId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emrecIdEoc',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.grid.emrecIdEoc',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eocName',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.grid.eocName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eocNodeId',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.grid.eocNodeId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eocStatusNodeId',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.grid.eocStatusNodeId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eocStatusWarnGte',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.grid.eocStatusWarnGte',
        sortable: true,
        form: {
        type: 'inputNumber'
        }
        },
        {
        key: 'eocStatusWarnLt',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.grid.eocStatusWarnLt',
        sortable: true,
        form: {
        type: 'inputNumber'
        }
        },
        {
        key: 'eocStatusErrorGte',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.grid.eocStatusErrorGte',
        sortable: true,
        form: {
        type: 'inputNumber'
        }
        },
        {
        key: 'eocStatusErrorLt',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.grid.eocStatusErrorLt',
        sortable: true,
        form: {
        type: 'inputNumber'
        }
        },
        {
        key: 'eocNodeCode',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.grid.eocNodeCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eoctName',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.grid.eoctName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    emrecIdEafmFilter : '',
    emrecIdEafmInFilter : [],
    eafmNameFilter : '',
    emrecIdEocFilter : '',
    eocNameFilter : '',
    eocNodeIdFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'emrecIdEafmFilter',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.filter.emrecIdEafm',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAdmFactoryModelEafm'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'eafmNameFilter',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.filter.eafmName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'emrecIdEocFilter',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.filter.emrecIdEoc',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'eocNameFilter',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.filter.eocName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eocNodeIdFilter',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.filter.eocNodeId',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'emrecSeq',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.entity.emrecSeq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'emrecIdEafm',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.entity.emrecIdEafm',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emAdmFactoryModelEafm'
            ,correspondingField: 'id'
            ,fieldsBindingByEntityModalSelected: '{"eamfNodeCode":"nodeCode","eafmName":"name"}'
                }
        },
        {
        key: 'eafmNodeCode',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.entity.eafmNodeCode',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eafmName',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.entity.eafmName',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'emrecIdEoc',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.entity.emrecIdEoc',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'id'
            ,fieldsBindingByEntityModalSelected: '{"eocNodeCode":"nodeCode","eocName":"name","eocNodeId":"eocNodeId"}'
                }
        },
        {
        key: 'eocName',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.entity.eocName',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eocNodeId',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.entity.eocNodeId',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eocNodeCode',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.entity.eocNodeCode',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.emSicEafmREocEmrec.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmSicEafmREocEmrec, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
